import Dropdown from "../Dropdown";
import { projectMenus } from "../ProjectMenus";

export default function FourDMenu(props) {
  return (
    <Dropdown
      menuKey="fourd"
      menu={projectMenus.fourd}
      isLast={true}
      {...props}
    />
  );
}
